// src/pages/MapPage.js

import React, { useRef, useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import "./MapPage.css";

import WM from "../../components/WM";
import BackSearchGo from "../../components/BackSearchGo";

import { VISITED_PLACES } from "../../data/VisitedPlaces";
import { VISITED_PATHS } from "../../data/VisitedPaths";

import { ReactComponent as WorldMap } from "../../images/WM.svg";
import { ReactComponent as USMap } from "../../images/US.svg";
import { ReactComponent as PuertoRicoMap } from "../../images/puertorico.svg";
import OregonMap from "./OregonMap";
import ColoradoMap from "./ColoradoMap";
import NewJerseyMap from "./NewJerseyMap";





export default function MapPage() {
  const { region } = useParams();
  const navigate = useNavigate();
  const location = useLocation();   // ⭐ NEW
  const mapRef = useRef(null);

  // ⭐ highlightId coming from GlobeSearch navigation
  const highlightId = location.state?.highlightId || null;

  // ⭐ Store the search term until the map switches
  const [pendingSearch, setPendingSearch] = useState(null);

  // ⭐ Clear highlight whenever region changes
  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.highlightPlace(null);
    }
  }, [region]);

  const MAPS = {
    world: WorldMap,
    usa: USMap,
    puertorico: PuertoRicoMap,
      oregon: OregonMap,
    colorado: ColoradoMap,
    newjersey: NewJerseyMap,
  };

  const SelectedMap = MAPS[region] || USMap;


  // ⭐ When region changes, apply pending search ONCE
  useEffect(() => {
    if (!pendingSearch) return;
    if (!mapRef.current) return;

    mapRef.current.highlightPlace(pendingSearch);
    setPendingSearch(null); // clear after use
  }, [region, pendingSearch]);

  // ⭐ Apply highlightId from search navigation (Puerto Rico fix)
  useEffect(() => {
    if (!highlightId) return;
    if (!mapRef.current) return;

    mapRef.current.highlightPlace(highlightId);
  }, [highlightId]);

  // ⭐ Reset everything when user starts typing
  const handleNewSearch = () => {
    setPendingSearch(null);
    if (mapRef.current) {
      mapRef.current.highlightPlace(null);
    }
  };

  return (
    <div className="App travel-screen map-page">
      <div className="searchbar-top-container">
        <BackSearchGo
          onNewSearch={handleNewSearch}
          onHighlight={(name, targetRegion) => {
            if (!name) return;

            const normalized = name.toLowerCase();

            // ⭐ If search requires switching maps → store request
            if (targetRegion && targetRegion !== region) {
              setPendingSearch(normalized);
              navigate(`/map/${targetRegion}`);
              return;
            }

            // ⭐ Already on correct map → highlight immediately
            if (mapRef.current) {
              mapRef.current.highlightPlace(normalized);
            }
          }}
        />
      </div>

      <div className="map-container">
        <WM
          ref={mapRef}
          SVGMap={SelectedMap}
          svgClass={`${region}-map-svg`}
          visitedList={VISITED_PLACES}
          onRegionClick={(id) => {
            const key = id.toLowerCase();
            const path = VISITED_PATHS[key];

            if (!path) {
              alert(`${id} is not visited yet`);
              return;
            }

            navigate(path);
          }}
        />
      </div>
    </div>
  );
}
